import * as moment from 'moment';
import { ICoachDrawerChampion, IMicrositeRecipientForList } from "@nkr/models/microsites"
import { ViewWrapper } from "./styles"
import { Col, Label, Row, Well } from "react-bootstrap"
import { PhoneType } from "@nkr/enums/phone-type";
import ClipButton from '@nkr/components/clip-button';
import { Utility } from '@nkr/services/utility';

interface IProps {
    data: IMicrositeRecipientForList,
    champion: ICoachDrawerChampion | null,
    isAdmin: boolean
}

export default function DetailHeader({ data, champion, isAdmin }: IProps) {
    const coordinatorPhone = data.coordinatorContact != null ? data.coordinatorContact.phoneNumbers.find(x => x.phoneTypeId == PhoneType.Office) : null;
    const secondaryCoordinatorPhone = data.secondaryCoordinatorContact != null ? data.secondaryCoordinatorContact.phoneNumbers.find(x => x.phoneTypeId == PhoneType.Office) : null;

    const url = `${__NKR_ORG_URL__}/${data.shortCode}`;

    return (
        <ViewWrapper>
            <Well bsSize='sm' style={{ marginBottom: 5 }}>
                <Row>
                    <LabelCol>Name:</LabelCol>
                    <DataCol>{data.firstName} {data.lastName}</DataCol>
                </Row>

                <Row>
                    <LabelCol>Email:</LabelCol>
                    <DataCol>{data.email}</DataCol>
                </Row>

                {data.secondaryEmail &&
                    <Row>
                        <LabelCol>Secondary Email:</LabelCol>
                        <DataCol>{data.secondaryEmail}</DataCol>
                    </Row>
                }

                <Row>
                    <LabelCol>Phone:</LabelCol>
                    <DataCol>{data.phonePrimary ? data.phonePrimary : '- not specified -'}</DataCol>
                </Row>

                {data.phoneSecondary &&
                    <Row>
                        <LabelCol>Secondary Phone:</LabelCol>
                        <DataCol>{data.phoneSecondary}</DataCol>
                    </Row>
                }

                <Row>
                    <LabelCol>Address:</LabelCol>
                    <DataCol>
                        {data.addressLine1}<br />
                        {data.addressLine2 && <>{data.addressLine2}<br /></>}
                        {data.city}, {data.state} {data.postalCode}
                    </DataCol>
                </Row>

                <Row>
                    <LabelCol>Birth Date:</LabelCol>
                    <DataCol>{data.birthdate ? moment(data.birthdate).format('MM/DD/YYYY') : ''} ({data.age})</DataCol>
                </Row>

                <Row>
                    <LabelCol>Gender:</LabelCol>
                    <DataCol>{data.gender == 1 ? 'Male' : 'Female'}</DataCol>
                </Row>

                {champion &&
                    <Row>
                        <LabelCol>Champion:</LabelCol>
                        <DataCol>
                            {champion.name}<br />
                            {champion.email}<br />
                            {Utility.formatPhone(champion.phone)}
                        </DataCol>
                    </Row>
                }

                {data.languagePreference &&
                    <Row>
                        <LabelCol>Language Preference:</LabelCol>
                        <DataCol>{data.languagePreference}</DataCol>
                    </Row>
                }

                {data.businessCardsRequestDate &&
                    <Row>
                        <LabelCol>Business Cards Requested:</LabelCol>
                        <DataCol>{moment(data.businessCardsRequestDate).format('MM/DD/YYYY')}</DataCol>
                    </Row>
                }

                <Row>
                    <LabelCol>Status:</LabelCol>
                    <DataCol>{data.currentStatusDescription}</DataCol>
                </Row>

                <Row>
                    <LabelCol>Microsite URL:</LabelCol>
                    <DataCol>
                        <a title={url} href={url} target='_blank'>{url}</a>&nbsp;
                        <ClipButton value={url} title="Copy URL to Clipboard" />
                    </DataCol>
                </Row>

                {data.center != null ?
                    <>
                        <Row>
                            <LabelCol>Center:</LabelCol>
                            <DataCol>
                                {data.center.alias ? data.center.alias : '- pending selection -'}
                                {data.center.isUtilizing3gKidneyForLife && <>&nbsp;<Label bsSize="xsmall" bsStyle='success'>KFL</Label></>}
                            </DataCol>
                        </Row>

                        <Row>
                            <LabelCol>Coordinator:</LabelCol>
                            <DataCol>
                                {data.coordinatorContact ? (<>
                                    {data.coordinatorContact.fullName}<br />
                                    {data.coordinatorContact.email}<br />
                                    {coordinatorPhone?.number ? coordinatorPhone?.number : '[phone not found]'}
                                </>) : '- pending selection -'}
                            </DataCol>
                        </Row>
                        {data.secondaryCoordinatorContact &&
                            <Row>
                                <LabelCol>2nd Coordinator:</LabelCol>
                                <DataCol>
                                    {data.secondaryCoordinatorContact.fullName}<br />
                                    {data.secondaryCoordinatorContact.email}<br />
                                    {secondaryCoordinatorPhone?.number ? secondaryCoordinatorPhone?.number : '[phone not found]'}
                                </DataCol>
                            </Row>
                        }
                    </>
                    :
                    <>
                        <Row>
                            <LabelCol>Center:</LabelCol>
                            <DataCol>CLM</DataCol>
                        </Row>
                    </>
                }

                {isAdmin &&
                    <>
                        <Row>
                            <LabelCol>&nbsp;</LabelCol>
                            <DataCol>&nbsp;</DataCol>
                        </Row>

                        <Row>
                            <LabelCol>Assigned Coach:</LabelCol>
                            <DataCol>{data.coachContact ? data.coachContact.fullName : '- pending selection -'}</DataCol>
                        </Row>
                    </>
                }

            </Well>
        </ViewWrapper>
    );
}

const LabelCol = ({ children }) => {
    return (
        <Col xs={12} lg={4} style={{ fontWeight: 500 }}>{children}</Col>
    )
}

const DataCol = ({ children }) => {
    return (
        <Col xs={12} lg={8}>{children}</Col>
    )
}